/**
 * This file contains the dimensions for the various modals used in the application.
 */ // Widths used for primary dialogs
export const MainDialogMaxWidth = "800px";
export const MainDialogMinWidth = "300px";
export const MainDialogWidth = "70%";
export const DialogWithRightPanelMaxWidth = "1120px";
export const DialogWithRightPanelMinWidth = "620px";
export const DialogWithRightPanelWidth = "70%";
// Height used for primary dialogs
export const TaskEditorTodoDialogHeight = "565px";
export const TaskEditorSharedDialogHeight = "771px";
export const TaskEditorMaxDialogHeight = "calc(100vh - 32px)";
